import tingle from 'tingle.js';
import { NumberOfUsersInput } from "../numberOfUsersInput";
import { ModuleInput } from "../moduleInput";
import { ExtraInput } from "../extraInput";
import { GtmDataLayer } from '../../data/gtmDataLayer';

export class PackageConfigurationStep {
    /**
     * Component that handles the configuration step.
     * @constructor
     * @param {Object} options
     * @param {Object} options.store
     */
    constructor(options) {
        this.store = options.store;
        this.state = this.store.getState();
        this.$el = document.createElement('div');
        this.modal = this.createModal();
        this.translations = options.translations;
        this.addProductToDataLayer(this.state.product);

        for (const user of this.state.users) {
            this.$el.appendChild(this.createNumberOfUsersInput(options, user));
        }

        const moduleHeading = document.createElement('h2');
        moduleHeading.classList.add('module__heading', 'h4', 'mt-5');
        moduleHeading.innerHTML = this.translations.step_1_addons ? this.translations.step_1_addons : __('Useful add-ons for your subscription');

        if (this.state.modules[0]) {
            this.$el.appendChild(moduleHeading);
        }

        for (const module of this.state.modules) {
            this.$el.appendChild(this.createModulesInput(options, module));
        }

        const extraHeading = document.createElement('h2');
        extraHeading.classList.add('extra__heading', 'h4', 'mt-5');
        extraHeading.innerHTML = __('Extra services');

        if (this.state.extras[0]) {
            this.$el.appendChild(extraHeading);
        }

        for (const extra of this.state.extras) {
            this.$el.appendChild(this.createExtrasInput(options, extra));
        }
    }

    addProductToDataLayer(product) {
        const gtmProductData = {
            name: product.name,
            id: product.id,
            price: product.amount,
            quantity: 1,
            productCode: product.productCode,
            packageCode: product.packageCode,
        };
        const gtmStepData = {
            name: this.state.steps.find(step => step.current === true).name,
            id: this.state.steps.find(step => step.current === true).id,
        };

        GtmDataLayer.addToCart(gtmProductData, gtmStepData);
    }

    createNumberOfUsersInput(options, user) { // eslint-disable-line class-methods-use-this
        const numberOfUsersInput = new NumberOfUsersInput({
            ...options,
            id: user.id,
            userType: user.userType,
            minNumberOfUsers: parseInt(user.minNumberOfUsers, 10),
            maxNumberOfUsers: parseInt(user.maxNumberOfUsers, 10),
            numberOfUsers: parseInt(user.numberOfUsers, 10),
            numberOfFreeUsers: parseInt(user.numberOfFreeUsers, 10),
            amountPerUser: parseFloat(user.amountPerUser),
            tooltip: user.tooltip,
            description: user.description,
            name: user.name,
            unit: user.unit,
            dependency: user.dependency,
            contentProviders: user.contentProviders.map(e => ({
                ...e,
                amount: parseFloat(e.amount)
            })),
            chosenProvider: user.chosenProvider,
            limits: this.translations.shared_limits
        });

        return numberOfUsersInput.render();
    }

    createModulesInput(options, module) { // eslint-disable-line class-methods-use-this
        const moduleInput = new ModuleInput({
            ...options,
            internalId: module.internalId,
            id: module.id,
            moduleType: module.moduleType,
            name: module.name,
            label: module.label,
            labelType: parseInt(module.labelType, 10),
            amount: parseInt(module.amount, 10),
            unit: module.unit,
            description: module.description,
            readMoreLink: module.readMoreLink,
            bundlePrice: parseFloat(module.bundlePrice),
            nonBundlePrice: parseFloat(module.nonBundlePrice, 10),
            bundleQuantity: parseInt(module.bundleQuantity, 10),
            numberOfItems: parseInt(module.numberOfItems, 10),
            hideNonBundlePrice: parseInt(module.hideNonBundlePrice, 10),
            builtInPackage: parseInt(module.builtInPackage, 10),
            billingUnit: module.billingUnit,
            billingUnitPlural: module.billingUnitPlural,
            active: module.active,
            modal: this.modal,
        });

        return moduleInput.render();
    }

    createExtrasInput(options, extra) { // eslint-disable-line class-methods-use-this
        const extraInput = new ExtraInput({
            ...options,
            id: extra.id,
            extraType: extra.extraType,
            name: extra.name,
            label: extra.label,
            labelType: parseInt(extra.labelType, 10),
            amount: parseInt(extra.amount, 10),
            unit: extra.unit,
            description: extra.description,
            readMoreLink: extra.readMoreLink,
            active: extra.active,
            modal: this.modal,
        });

        return extraInput.render();
    }

    // eslint-disable-next-line class-methods-use-this
    createModal() {
        // eslint-disable-next-line new-cap
        const modal = new tingle.modal({
            closeMethods: ['overlay', 'button', 'escape'],
            closeLabel: 'Sluiten',
            beforeClose() {
                // here's goes some logic
                // e.g. save content before closing the modal
                return true; // close the modal
            }
        });

        return modal;
    }

    render() {
        return this.$el;
    }
}

export default PackageConfigurationStep;
